
export default {
  install(vue, router) {
    const crumbs = vue.observable({
      crumbs: [],
    });
    vue.prototype.$crumbs = crumbs;
    function addCrumb(crumb) {
      crumbs.crumbs.unshift(crumb);
    }
    function reset() {
      crumbs.crumbs = [];
    }
    function setCrumbs(route) {
      if (!route || !route.meta || !route.meta.breadcrumb) {
        return false;
      }
      if (typeof route.meta.breadcrumb === 'string') {
        addCrumb({
          label: route.meta.breadcrumb,
          href: route.path,
          name: route.name,
        });
      } else if (typeof route.meta.breadcrumb === 'boolean') {
        if (route.meta.title) {
          addCrumb({
            label: route.meta.title,
            href: route.path,
            name: route.name,
          });
        }
      } else if (typeof route.meta.breadcrumb === 'object') {
        let label;
        if (route.meta.breadcrumb.label) {
          label = route.meta.breadcrumb.label;
        } else if (route.meta.title) {
          label = route.meta.title;
        }
        addCrumb({
          label,
          href: route.path,
          name: route.name,
        });
        if (route.meta.breadcrumb.parent) {
          const parent = router.resolve({ name: route.meta.breadcrumb.parent });
          if (parent) {
            return setCrumbs(parent.route);
          }
        }
        return true;
      }
    }
    function updateCrumbs() {
      reset();
      setCrumbs(router.currentRoute);
    }

    router.afterEach(() => {
      updateCrumbs();
    });
  },
};
